import React, { Component } from 'react';
// import Link from '../components/link';
import { Link, Redirect } from 'react-router-dom';
import {API_ENDPOINT} from "../constants";

import Isvg from 'react-inlinesvg';
import Page from '../containers/page';

import logo from '../assets/logo.svg';
import warning from '../assets/svg/x-icon-2.svg'
import zajednica from '../assets/zajednica.svg';
import login from '../assets/images/login.png';
import shape1 from '../assets/svg/shape-1.svg';
import shape2 from '../assets/svg/shape-2.svg';

import {
    Container,
    Row,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
    UncontrolledDropdown
} from 'reactstrap';

import Form from '../components/forms/loginForm';
import ResetPasswordFrom from '../components/forms/resetPasswordForm'
import moment from 'moment';


var striptags = require('striptags');

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            changePassword: false,
            today: moment().format('dddd, DD.MM.YYYY.')
        };
    }

    componentDidMount() {

        // if (typeof window !== 'undefined') { window.scrollTo(0, 0); }


        // for (let i = 0; i < this.props.loadData.length; i++) {
        //     this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match).then((data) => {
        //         this.setState({
        //             ...data
        //         })
        //     })
        // }
        let day = this.state.today.split(",")[0];
        if(day == 'Monday'){
            day = "Ponedeljak";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }else if(day == 'Tuesday'){
            day = "Utorak";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }else if(day == 'Wednesday'){
            day = "Srijeda";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }else if(day == 'Thursday'){
            day = "Četvrtak";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }else if(day == 'Friday'){
            day = "Petak";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }else if(day == 'Saturday'){
            day = "Subota";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }else if(day == 'Sunday'){
            day = "Nedelja";
            this.setState({ today: day + "," + this.state.today.split(",")[1]})
        }

        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

    }



    submit(data) {
        if(!data.checked){
            data.checked = false;
        }
        fetch(`${API_ENDPOINT}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then((res) => res.json()).then((result) => {
            if (!result.error) {
                let token = result.token;
                localStorage.setItem('token', token);
                if (result.changePassword){
                 this.setState({changePassword: true})
                } else{
                    this.props.verifyUser()
                    this.props[0].history.push('/');
                }
            } else {
                this.setState({
                    error: result.error
                })
            }
        })
    }
    submitResetPassword(data){
        if (data.newPassword !== data.newPasswordConfirm){
            this.setState({error: 'Nove lozinke se ne podudaraju'})
        } else{
            if (!this.isValidPassword(data.newPassword)){
                this.setState({error: 'Lozinka mora da sadrži najmanje 5 karaktera, uključujući najmanje jedan broj i najmanje jedan specijalni znak (npr. !, @, #, $, %, itd.).'})
            } else{
                fetch(`${API_ENDPOINT}/change/password`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    },
                    body: JSON.stringify({oldPassword:data.oldPassword, newPassword: data.newPassword})
                }).then((res) => res.json()).then((result) => {
                    if (!result.error) {
                            this.props.verifyUser()
                            this.props[0].history.push('/');
                    } else {
                        this.setState({
                            error: result.error
                        })
                    }
                })
            }
        }
    }

    isValidPassword(password) {
        const minLength = password.length >= 5;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        return minLength && hasNumber && hasSpecialChar;
    }
    render() {

        return (
            <div className="test">
                
                <img src={shape1} className="shape-1" />
                <img src={shape2} className="shape-2" />
                {/* {
                    typeof localStorage !== 'undefined' && localStorage.token ? <Redirect to='/' /> : null
                } */}
                {/* <Redirect to='/' />  */}
                <Container className="login-header">
                    <Row>
                        <Col lg="6">
                            <Isvg src={logo} />
                            <Isvg src={zajednica} />
                        </Col>
                        <Col lg="6" className="nav-right mr30">
                            <div className="date-container">
                                <span className="date-login">{this.state.today}</span>
                                <span className="time">{moment().format('HH:mm')}</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container className="login-page">

                    <Row className="login-page-container">
                        <div className="login-page-left">
                            <div className="login-box">
                                { !this.state.changePassword ?
                                    <>
                                <h2>Dobrodošli</h2>
                                <p>Ulogujte se sa svojim pristupnim podacima kako bi pristupili EuroExpress brza pošta internom portalu</p>
                                <img src={login} />
                                </>
                             : <>
                                        <h2>Upozorenje!</h2>
                                        <p>Lozinka koju koristite je slaba. Zbog sigurnosti vašeg naloga, preporučujemo da je odmah zamijenite jačom.</p>
                                        <img class='warning-login-image' src={warning} />
                                    </>
                            }
                            </div>
                        </div>
                        <div className="login-wrap login-page-right">
                            <div className={`login-wrap-container ${this.state.changePassword && 'pt-4'}`}>
                                { !this.state.changePassword ? <>
                                    <h2>Login</h2>
                                    <Form onSubmit={this.submit} />
                                    <p className="login-error">{this.state.error}</p>
                                </> : <>
                                    <h2>Promjena lozinke</h2>
                                    <ResetPasswordFrom onSubmit={this.submitResetPassword.bind(this)} />
                                    <p className="login-error pb-3 pt-2">{this.state.error}  </p>
                                </>}

                            </div>
                        </div>

                        {/*
                        <Col lg={{ size: 8, offset: 2 }} className="login-wrap">
                            <div className="login-header">
                                <img src={logo} />
                                <img src={zajednica} />
                            </div>
                            <hr />
                            <div className="login-title">
                                <h1>LOGIN</h1>
                            </div>
                            <Form onSubmit={this.submit} />
                        </Col>
                        */}

                    </Row>
                </Container>

                <Container className="login-footer">
                    <Row>
                        <Col lg="6">
                            <span>© 2020 EuroExpress brza pošta.
                                <br></br>
                            All rights reserved.</span>
                        </Col>
                    </Row>
                </Container>

            </div>
        );
    }
}

export default Page(LoginPage);